import { Form, Input, Button, Checkbox, Spin } from "antd";
import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { useState } from 'react'
import { useNavigate } from "react-router-dom";
import "../../App.css";
import api from "../api";

const Login = () => {
  const navigate = useNavigate();
  const [loginError, setLoginError] = useState("");
  const [loading, setLoading] = useState(false);


  const showError = (msg) => {
    setLoginError(msg);
    setTimeout(() => {
      setLoginError("");
    }, 3000);
  };

  const onFinish = async (values) => {
    // console.log("Success:", values);

    setLoginError("");


    const requestData = {
      synceddatetime: "15-07-2025 12:57:45",
      FormCode: "201",
      ApiKey: "kavin",
      AppTypeNo: "3",
      AppVersion: "1.0.0",
      data_source: "W",
    };

    try {
      setLoading(true)
      const response = await api.loginApi(
        values.username,
        values.password,
        requestData
      );
      if (response.status === "1") {

        const sessionData = {
          username: values.username,
          loginTime: Date.now(),
          password: response?.loged_in_details?.[0]?.fld_password 
        };
        localStorage.setItem("session", JSON.stringify(sessionData));
        navigate("/main/directory");

      } else {
        showError(response.responsemessage || "Login Failed");
      }

      // console.log("response...", response);
    } catch (error) {
      showError("Something went wrong, please try again.");
      console.error("login api error", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <Spin spinning={loading}>
        <div className="logo-wrapper">
          <img src="/Logo.png" alt="App Logo" className="login-logo" />
        </div>
        <div className="login-container">
          <h2 className="login-title">Login to Account</h2>
          <p className="login-subtitle">
            Please enter your username and password to continue
          </p>

          <Form
            layout="vertical"
            onFinish={onFinish}
            className="login-form"
            initialValues={{ remember: false }}
          >
            <Form.Item
              label="Username:"
              name="username"
              rules={[
                { required: true, message: "Username is required" },
                { min: 3, message: "Username must be at least 3 characters" },
              ]}
            >
              <Input
                prefix={<UserOutlined />}
                placeholder="Enter your username"
              />
            </Form.Item>

            <Form.Item
              label="Password"
              name="password"
              rules={[{ required: true, message: "Password is required" }]}
            >
              <Input.Password
                prefix={<LockOutlined />}
                placeholder="Password"
              />
            </Form.Item>

            {loginError && (
              <div className="login-error">{loginError}</div>
            )}

            {/* <div className="login-options">
              <a className="forgot-password" onClick={() => navigate("/changePassword")}>
                Change Password?
              </a>
            </div> */}
            <Form.Item className="signIn-button">
              <Button type="primary" htmlType="submit" className="login-button">
                Sign In
              </Button>
            </Form.Item>

          </Form>
        </div>
      </Spin>
    </div>
  );
};

export default Login;
